import { Box } from "@mui/material";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

/**
 * The laser mark with a "!" (Feature #3502): a laser deductible that needs
 * review. Inherits colour from its parent (warning on the flag and banner).
 * Takes `className` so MUI slots (Chip `icon`, Alert `icon`) can style it.
 */
export const LaserReviewIcon = ({ size = 16, className }: { size?: number; className?: string }) => (
  <Box component="span" aria-hidden className={className} sx={{ display: "inline-flex", alignItems: "center" }}>
    <GpsFixedIcon sx={{ fontSize: size }} />
    <PriorityHighIcon sx={{ fontSize: Math.round(size * 0.85), ml: -0.4 }} />
  </Box>
);
